import { Dialog } from "@base-ui/react/dialog";
import { IconButton } from "@circleco/compass/components/IconButton";
import type { ComponentPropsWithoutRef, ReactNode, Ref } from "react";

import { t } from "@/i18n-js/instance";

interface MobilePostModalHeaderProps extends Omit<
  ComponentPropsWithoutRef<"header">,
  "title"
> {
  children: ReactNode;
  closeButtonRef?: Ref<HTMLButtonElement>;
  title: string;
}

export const MobilePostModalHeader = ({
  children,
  closeButtonRef,
  title,
  ...headerProps
}: MobilePostModalHeaderProps) => (
  <header
    className="flex flex-row items-center border-b border-primary px-4 py-3"
    {...headerProps}
  >
    <Dialog.Close
      ref={closeButtonRef}
      render={
        <IconButton
          variant="ghost"
          size="sm"
          icon="arrow-left"
          aria-label={t("post.post_modal.go_back")}
        />
      }
    />
    <Dialog.Title className="sr-only">{title}</Dialog.Title>

    <div className="ml-auto flex items-center gap-1">{children}</div>
  </header>
);
